import React from 'react';

interface TableSkeletonProps {
  rows?: number;
  cols?: number;
}

export function TableSkeleton({ rows = 5, cols = 4 }: TableSkeletonProps) {
  return (
    <div className="w-full animate-pulse space-y-3">
      {/* Table Header */}
      <div className="grid grid-cols-4 gap-4 border-b border-slate-200 dark:border-slate-800 pb-3 px-4">
        {Array.from({ length: cols }).map((_, idx) => (
          <div key={idx} className="h-4 rounded bg-slate-200 dark:bg-slate-700 w-3/4" />
        ))}
      </div>
      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, rIdx) => (
        <div
          key={rIdx}
          className="grid grid-cols-4 gap-4 py-3 px-4 border-b border-slate-100 dark:border-slate-800/60 items-center"
        >
          {Array.from({ length: cols }).map((_, cIdx) => (
            <div
              key={cIdx}
              className={`h-4 rounded bg-slate-200 dark:bg-slate-700 ${
                cIdx === 0 ? 'w-full' : cIdx === 1 ? 'w-2/3' : 'w-1/2'
              }`}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
